import { TOGGLE_NAVIGATION } from './actionTypes'

export const toggleNavigation = () => ({
  type: TOGGLE_NAVIGATION
})
